import handorgel from 'handorgel';

const accordion = new handorgel(document.querySelector('.tabs-mobile'), {
  // whether multiple folds can be opened at once
  multiSelectable: false,
  // whether the folds are collapsible
  collapsible: true
})
